/**
 *
 * WidgetListOutcomes
 *
 */
import React, { Fragment, useEffect, useRef, useState } from "react"
import { compose } from "redux"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectIsLoading, makeSelectDimensionsOutcomes } from "./selectors"
import { getDimensionsOutcomesWatcher } from "./actions"

import { Divider, Popover, Spin } from "antd"
import "./index.less"
import { uuid, validate } from "../../../../../utils/functions"
import {
  isAmbassadorActive,
  isModuleBySlug,
} from "../../../../../utils/storage"
import { BENCHMARK, HISTORICAL_ANALYSIS } from "../../../../../utils/constants"
import { get } from "lodash"
import PopoverBenchmark from "../../../PopoverBenchmark"
import { ArrowDownIcon } from "../../../../../icons/svg/iconArrowDown"
import { ArrowUpIcon } from "../../../../../icons/svg/iconArrowUp"
import { loadTexts } from "../../../../../utils/i18n"
import { QuestionCircleFilled } from "@ant-design/icons"
import  alertBoxOutline  from "../../../../../images/alert-box-outline.svg"
import threePointsGray from "../../../../../images/three-points-gray-config.svg"
import DOMPurify from "dompurify"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function WidgetListOutcomes(props) {
  const intlWidgetOutcomes = loadTexts("reports_general_view").reportAmbassador
    .engagementMeasurement.widgetListOutcomes
  const [measureID] = useState(props.idMeasure)
  const [divisionID] = useState(props.idDivisionSelected)
  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)
  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = async () => {
    const {
      idMeasure,
      getDimensionsOutcomes,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props
    getDimensionsOutcomes({
      isHome: true,
      id_measure: idMeasure,
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    })
  }

  const renderTitleOutcome = (row) => {
    const { measureGeneral } = props
    const validDate =  new Date(row.date_processed) >= new Date(2024, 2);
    const enpsScale10=(measureGeneral.id_survey_type==1 && measureGeneral.is_engagement==true &&
      row.id_dimension==39 && row.id_dimension_category==3 && row.scale==10 && validDate)
    const sanitizedHTML = DOMPurify.sanitize(row.dimension_description || row.dimension_name);
    return (
      <div className="WidgetListOutcomes-body-item-top-title">
        <Popover
          content={
            <div style={{ maxWidth: 350, textAlign: "justify" }}>
              <span
                dangerouslySetInnerHTML={{
                  __html: sanitizedHTML,
                }}
              />
              <Divider
                style={{
                  margin: "10px -16px",
                  textAlign: "justify",
                  width: "calc(100% + 32px)",
                }}
              />
              {row.metrics_questions && row.metrics_questions.length > 0 && (
                <Fragment>
                  <b style={{ color: "#878787" }}>Pregunta:</b>
                  <br />
                  {row.metrics_questions.map((x, iQ) => (
                    <Fragment key={iQ}>
                      {x.name} <br />
                    </Fragment>
                  ))}
                </Fragment>

              )}
            </div>
          }>
          <span>{row.name}</span>

        </Popover>
        {(enpsScale10 && measureGeneral.top_three_box_enable) && (
           <Popover className="custom-icon-info"
           placement="top"
           trigger="hover"
           content={
             <div >
                 <p style={{ textAlign: "justify", marginBottom: '0'  }}>
                 Este indicador es calculado con el método <br></br>
                 Top Three Box. Es decir, se considerarán<br></br>
                 como valores <b>bajos</b> los puntajes del 0 al 4,<br></br>
                 <b>medios</b> los puntajes 5, 6 y 7, y <b>altos</b> 8, 9 y 10.
                 </p>
                 <p style={{color:"#979797"}}> <img style={{ marginBottom:3 }} src={alertBoxOutline} alt=""/> Cálculo vigente desde el 2024.</p>

             </div>

           }>
           {" "}
           <QuestionCircleFilled className="custom-icon-info" style={{color: "#A7A3A3"}}/>
         </Popover>
        )}

      </div>

    )
  }

  const renderContentOutcome = (row) => {
    return (
      <div
        className="WidgetListOutcomes-body-item-top-content"
        style={{ backgroundColor: row.color }}>
        {row.value_visible}
      </div>
    )
  }

  const renderPreviousValue = (row) => {
    const { measureGeneral } = props
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    if (
      !validate.exist(row.calculate_comparative) ||
      !row.calculate_comparative.show ||
      !isHistoricalAnalysis 
    ) {
      return null
    }
    let isBenchmarkRender = true
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!validate.exist(row.benchmark) || !row.benchmark.show || !isBenchmark) {
      isBenchmarkRender = false
    }
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      isBenchmarkRender = false
    }
    return (
      <div
        className={`WidgetListOutcomes-body-item-footer-previous ${
          isBenchmarkRender ? "benchmark" : ""
        }`}>
        <div className="WidgetListOutcomes-body-item-footer-previous-title">
          {intlWidgetOutcomes.previousMeasure}
        </div>
        <div className="WidgetListOutcomes-body-item-footer-previous-content">
          <div className="WidgetListOutcomes-body-item-footer-previous-content-value">
            {`${Math.round(row.calculate_comparative.prev_value)}%`}
          </div>
          <div
            className={`WidgetListOutcomes-body-item-footer-previous-content-compare ${
              get(row.calculate_comparative, "level")
                ? " green"
                : row.calculate_comparative.level === false
                ? " red"
                : ""
            }
            `}>
            <div
              style={{
                color: get(row.calculate_comparative, "level")
                  ? "#55C8AE"
                  : row.calculate_comparative.level === false
                  ? "#E37879"
                  : "",
              }}>
              {row.calculate_comparative.value}
            </div>
            {get(row.calculate_comparative, "level") ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : row.calculate_comparative.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderBenchmark = (row) => {
    const { measureGeneral } = props
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (!validate.exist(row.benchmark) || !row.benchmark.show || !isBenchmark) {
      return null
    }
    if (!measureGeneral.ambassador_benchmark_visible && isAmbassadorActive()) {
      return null
    }
    return (
      <div className="WidgetListOutcomes-body-item-footer-benchmark">
        <div className="WidgetListOutcomes-body-item-footer-benchmark-title">
          <PopoverBenchmark
            isGlobalBenchmark={measureGeneral.is_global_benchmark}
          />
        </div>
        <div className="WidgetListOutcomes-body-item-footer-benchmark-content">
          <div className="WidgetListOutcomes-body-item-footer-benchmark-content-value">
            {row.benchmark.value}
          </div>
          <div
            className={`WidgetListOutcomes-body-item-footer-benchmark-content-compare ${
              get(row.benchmark, "level")
                ? " green"
                : row.benchmark.level === false
                ? " red"
                : ""
            }
            `}>
            <div
              style={{
                color: get(row.benchmark, "level")
                  ? "#55C8AE"
                  : row.benchmark.level === false
                  ? "#E37879"
                  : "#4F4F4F",
              }}>
              {`${row.benchmark.variation}%`}
            </div>
            {get(row.benchmark, "level") ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : row.benchmark.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderFooter = (row) => {
    const { measureGeneral } = props
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const isBenchmark = isModuleBySlug(BENCHMARK)
    if (
      (!validate.exist(row.benchmark) ||
        !row.benchmark.show ||
        !isBenchmark ||
        (!measureGeneral.ambassador_benchmark_visible &&
          isAmbassadorActive())) &&
      (!validate.exist(row.calculate_comparative) ||
        !row.calculate_comparative.show ||
        !isHistoricalAnalysis)
    ) {
      return null
    }
    return (
      <div className="WidgetListOutcomes-body-item-footer">
        {get(measureGeneral, 'id_measure_status', 3) === 5 && renderPreviousValue(row)}
        {renderBenchmark(row)}
      </div>
    )
  }

  const renderContent = () => {
    const { dimensionsOutcomes } = props
    return (
      <div className="WidgetListOutcomes-body">
        {dimensionsOutcomes.map((row) => {
          return (
            <div key={uuid()} className="WidgetListOutcomes-body-item">
              <div className="WidgetListOutcomes-body-item-top">
                {renderTitleOutcome(row)}
                {renderContentOutcome(row)}
              </div>
              {renderFooter(row)}
            </div>
          )
        })}
      </div>
    )
  }

  const renderTitle = () => {
    const { showTitle } = props
    if (!showTitle) {
      return null
    }
    return (
      <div className="WidgetListOutcomes-title">
        <span>Outcomes</span>
      </div>
    )
  }

  if (props.isLoading) {
    return (
      <div className="WidgetListOutcomes">
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  return (
    <div className="WidgetListOutcomes">
      {renderTitle()}
      {renderContent()}
    </div>
  )
}
WidgetListOutcomes.propTypes = {
  isLoading: PropTypes.bool,
  showTitle: PropTypes.bool,
  dimensionsOutcomes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  history: PropTypes.object,
  measureGeneral: PropTypes.object,
  idMeasure: PropTypes.number,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  getDimensionsOutcomes: PropTypes.func,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  dimensionsOutcomes: makeSelectDimensionsOutcomes(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensionsOutcomes: (params) =>
      dispatch(getDimensionsOutcomesWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetListOutcomes", reducer })
const withSaga = injectSaga({ key: "widgetListOutcomes", saga })

export default compose(withReducer, withSaga, withConnect)(WidgetListOutcomes)
